<template>
    <div class="app-container"
         v-infinite-scroll="loadMore"
         infinite-scroll-disabled="loading"
         infinite-scroll-distance="10">
        <div class="app-content">
            <coupon v-for="(item, index) in coupons"
                    :key="index"
                    :coupon="item"
                    @couponClick="handleCouponClick"></coupon>
        </div>
        <div>
            <p v-show="loading"
               class="page-infinite-loading">
                {{loadingText}}
            </p>
            <p v-show="finished"
               class="page-infinite-loading">
                {{finishedText}}
            </p>
        </div>
    </div>
</template>
<script>
import coupon from './components/coupon.vue'
import { InfiniteScroll } from 'mint-ui'
import JSBridge from '../../jsbridge'
import { fetchGoodsQueryList } from '../../common/api/delicacy'
import { Toast } from 'mint-ui'
export default {
    name: 'onlineSelection',
    directives: { InfiniteScroll },
    data() {
        return {
            loading: true,
            loadingText: '正在加载更多...',
            finished: false,
            finishedText: '暂无更多内容',
            pageSize: 20,
            pageNo: 0,
            coupons: [],
            total: 0
        }
    },
    created() {
        this.fetchGoodsQueryList()
    },
    methods: {
        handleCouponClick(coupon) {
            let nativeParams = { shopGoodsId: coupon.shopGoodsId + '' }
            let params = {
                cmd: 'C0070004',
                params: JSON.stringify(nativeParams)
            }
            JSBridge.Common.Caller_Common_Base_cmd(params, () => {})
        },
        loadMore() {
            if (this.loading || this.finished) return
            this.fetchGoodsQueryList()
        },
        fetchGoodsQueryList() {
            this.loading = true
            this.finished = false
            let params = {
                pageSize: this.pageSize,
                pageNo: this.pageNo + 1,
                categoryId: this.$route.query.categoryNo
            }
            fetchGoodsQueryList(params)
                .then(res => {
                    let resData = res.data
                    if (resData.code === 0) {
                        if (resData.data.goodsPage.length === 0) {
                            this.loading = false
                            this.finished = true
                            return
                        }
                        this.pageNo++
                        this.total = resData.data.total || 0
                        this.coupons = this.coupons.concat(
                            resData.data.goodsPage
                        )
                    } else {
                        Toast(res.msg)
                    }
                })
                .catch(err => {
                    Toast(err)
                })
                .finally(() => {
                    this.$nextTick(() => {
                        this.loading = false
                        if (this.coupons.length >= this.total) {
                            this.finished = true
                        }
                    })
                })
        }
    },
    components: {
        coupon
    }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/px2rem.scss';
@import '../../assets/css/colors.scss';
.app-container {
    background-color: $bgColor;
    .app-content {
        padding: 0 px2rem(10);
        background-color: white;
    }
}
.page-infinite-loading {
    text-align: center;
    padding: px2rem(30) 0;
    line-height: px2rem(20);
    font-size: px2rem(12);
    color: $gray;
}
</style>
